import Image from "next/image"
import Link from "next/link"
import HeadingLabel from "@/common/partials/heading-label/heading-label"
import styles from "./article.module.css"
import classNames from "classnames"

export default function Article({
  post,
  classes = [],
  trackClick = () => {},
  showTag = true,
  showExcerpt = false,
  showDateline = true
}) {
  const dateLine = [
    post.meta.dateline.created,
    post.meta.dateline.readTime > 0
      ? post.meta.dateline.readTime + " min att läsa"
      : false
  ]

  const PostTag = () => {
    if (post.tag.url === null) {
      return <HeadingLabel>{post.tag.label}</HeadingLabel>
    }

    return (
      <Link href={post.tag.url} prefetch={false}>
        <HeadingLabel>{post.tag.label}</HeadingLabel>
      </Link>
    )
  }

  const sizes =
    !post.image || !post.image?.sizes || post.image.sizes.length === 0
      ? "(max-width: 768px) 100vw, (max-width: 1280px) 50vw, 25vw"
      : post.image.sizes

  return (
    <div className={classNames(styles.card, classes)}>
      <Link
        href={post.url}
        prefetch={false}
        onClick={(e) => trackClick(e, post.url)}>
        <div className={styles.imageWrapper}>
          <figure className={styles.image}>
            {post.image && (
              <Image
                className={styles.image}
                src={post.image.url}
                sizes={sizes}
                width={post.image.width}
                height={post.image.height}
                alt={post.image.alt}
              />
            )}
          </figure>
        </div>
      </Link>
      {showTag && <PostTag />}
      <Link href={post.url} prefetch={false}>
        <strong className="headline h5">{post.title}</strong>
      </Link>
      {showExcerpt && <p className={styles.lead}>{post.lead}</p>}
      {showDateline && (
        <div className={styles.byLine}>
          {post.meta.byline && <span>Av: {post.meta.byline}</span>}
          <span className="block">{dateLine.filter(Boolean).join(" • ")}</span>
        </div>
      )}
    </div>
  )
}
